import { render, staticRenderFns } from "./lp-select.vue?vue&type=template&id=0c98af75&"
import script from "./lp-select.vue?vue&type=script&lang=js&"
export * from "./lp-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports